<template>
    <div>
        <Navbar/>
        <div class="" v-if="page">{{page}}</div>

<!--        <h1>{{page.title}}</h1>-->
        <!-- Product -->
        <section class="bg-light product-section" :style="{backgroundImage: 'url(' + backgroundImage + ')'}" v-if="publications">
            <div class="py-4" :class="{'overlay': backgroundImage}">
                <div class="container" v-if="publications && product">
                    <Product
                        :product="product"
                        :publications="publications"
                        :state="selectedState"
                        :grade="grade"
                        :subject="`pages/${page.key}`"
                        :language="language"
                        :product-description="page.description"
                    />

                </div>
            </div>
        </section>

        <!-- Blocks -->
        <template v-for="block in page.blocks">
            <RawView v-if="block.type == 'raw'" block='block' />
            <StudentMaterialsView v-if="block.type == 'student_materials'" :block='block' />
            <TeacherMaterialsView v-if="block.type == 'teacher_materials'" :block='block' :publications='socialStudiesPublications' />
            <OnlineView v-if="block.type == 'online'" :block='block' />
            <WhatYouGetView v-if="block.type == 'wyg'" :block='block' />
        </template>
    </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import {mapState} from "vuex";
import {applyFilter} from "@/common/publicationFilters";
import Product from "@/components/Product";
import RawView from "@/components/blocks/RawView";
import StudentMaterialsView from "@/components/blocks/StudentMaterialsView";
import TeacherMaterialsView from "@/components/blocks/TeacherMaterialsView";
import OnlineView from "@/components/blocks/OnlineView";
import WhatYouGetView from "@/components/blocks/WhatYouGetView";
import DynamicProduct from "@/components/DynamicProduct";

export default {
    name: "DynamicProductPage",
    components: {
        DynamicProduct, WhatYouGetView, OnlineView, TeacherMaterialsView, StudentMaterialsView, RawView, Product, Navbar},
    props: ['pageId', 'grade', 'language'],
    data: ()=> ({
        page: {},
        publications: [],
        product: {},
    }),
    computed: {
        ...mapState({
            pages: state => state.stateData.pages,
            stateData: state => state.stateData.stateData,
            selectedState: state => state.stateData.selectedState,
            publicationResources: state => state.stateData.publicationResources,
        }),
        backgroundImage() {
            if (!this.stateData.product_bg)
                return null;

            let isUrl = this.stateData.product_bg.startsWith('http://')
                || this.stateData.product_bg.startsWith('https://')
                || this.stateData.product_bg.startsWith('//');

            if (isUrl) {
                return this.stateData.product_bg;
            }

            return '//' + this.stateData.product_bg;
        },
    },
    created() {
        this.$store.dispatch('getPages')
            .then(() => this.setPage());
    },
    watch: {
        '$route': {
            handler (route) {
                if (route.params.state && route.params.grade != null) {
                    this.setPage();
                    return;
                }

                this.$router.push({
                    name: 'dynamic-page',
                    params: {
                        pageId: this.pageId,
                        state: this.selectedState,
                        grade: 0,
                        subject: 'social-studies',
                        language: 'en'
                    }
                });
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        setPage() {
            this.page = this.pages.find((a) => a.key == this.pageId);
            this.publications = applyFilter(this.stateData.publications, this.page.filters);

            this.publications = _.orderBy(this.publications, 'grade')
            this.publications = _.uniqBy(this.publications, 'grade')

            this.product = this.getProduct();
            console.log(this.product);
        },
        getPublicationResources () {
            this.$store.dispatch('getPublicationResources')
        },
        getProduct() {
            let product = {};
            console.log(this.$route.params);

            _.filter(this.publications, publication => {
                if (publication.grade == this.$route.params.grade &&
                    publication.language == this.$route.params.language
                ) {
                    product = publication;
                }
            })

            if (product.sku && !this.publicationResources[product.sku]) {
                this.getPublicationResources();
            }
            return product;
        }
    }

}
</script>

<style scoped>

</style>